import React from 'react';
import './Title.css'
import logo from '../Logo.png'
import {NavLink} from "react-router-dom";

function Title({token, user, logout, login}) {
  return (
    <header className="site-header">
      <div className="site-identity">
        <a href="http://www.laek-rlp.de/"><img src={logo} title="LÄK-RLP" alt="Landesärztekammer Rheinland-Pfalz"/></a>
        <h1>Landesärztekammer Rheinland-Pfalz</h1>
      </div>
      <nav className="site-navigation">
        <ul className="nav">
          <li><a href="http://www.laek-rlp.de/"
                 title="LÄK-RLP" target="_blank" rel="noreferrer">LÄK-RLP</a></li>
          <li><a href="https://www.bundesaerztekammer.de/aerzte/medizin-ethik/wissenschaftlicher-beirat/veroeffentlichungen/haemotherapietransfusionsmedizin/richtlinie/"
                 title="Richtlinie Hämotherapie" target="_blank" rel="noreferrer">Richtlinie</a></li>
          {!token && <li onClick={login}><NavLink to="/login">Login</NavLink></li>}
          {token && <li onClick={logout}><NavLink to="/">{user} / Logout</NavLink></li>}
        </ul>
      </nav>
    </header>
  )
}

export default Title;
